import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = ['source']
  static values = {
    isCopied: { type: Boolean, default: false },
    resetButtonTime: { type: Number, default: 3 }, // in seconds
  }

  connect() {
    this.resetTimer = null
  }

  disconnect() {
    clearTimeout(this.resetTimer)
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.sourceTarget.innerText)

      this.isCopiedValue = true

      this.#scheduleTimerReset()
    } catch (error) {
      console.error('Failed to copy: ', error)
    }
  }

  // private

  #scheduleTimerReset() {
    if (this.resetTimer) {
      clearTimeout(this.resetTimer)
    }

    this.resetTimer = setTimeout(() => {
      this.isCopiedValue = false
    }, this.#resetButtonTimeValue)
  }

  get #resetButtonTimeValue() {
    return this.resetButtonTimeValue * 1000
  }
}
